module.exports = __webpack_public_path__ + "media/images/plus_icon-f663daed68ad88a2ad8155138984f476.svg";